import { RouteRecordRaw } from "vue-router";

import usePermissions from "@/hooks/use-permissions";
import { UserInspectorPage } from "@/modules/UserInspector";

import links from "./links";

const { canReadAbtests } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: "",
    component: UserInspectorPage,
    name: links.games.userInspector,
    props: true,
    meta: {
      title: "User Inspector",
      permission: canReadAbtests,
    },
  },
];
